import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type { RootState } from './store' // Importar RootState si se necesita para prepareHeaders
import { Logger } from '../lib/utils'; // Importar nuestra utilidad de logging

// Determinar la URL base según la configuración
const getBaseUrl = () => {
  // Usamos explícitamente /api para trabajar con el proxy de Vite
  return '/api';
};

// Usar URL relativa para que funcione con el proxy de Vite
export const apiSlice = createApi({
  reducerPath: 'api', // Nombre del slice en el store
  baseQuery: fetchBaseQuery({
    baseUrl: getBaseUrl(),
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      
      Logger.api("prepareHeaders - token:", token ? "Token existe" : "No hay token");
      
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
        // Usamos la versión segura del logger para la API
        Logger.api("Token añadido a cabeceras", { headers: { authorization: 'Bearer [REDACTED]' } });
      }
      
      // Añadir cabeceras para evitar problemas de caché
      headers.set('Cache-Control', 'no-cache, no-store, must-revalidate');
      headers.set('Pragma', 'no-cache');
      headers.set('Expires', '0');
      
      return headers;
    },
    timeout: 30000, // Timeout de 30 segundos para evitar peticiones que nunca terminan
    fetchFn: async (input, init) => {
      try {
        const response = await fetch(input, {
          ...init,
          signal: init?.signal || AbortSignal.timeout(30000) // Asegurar un timeout
        });
        return response;
      } catch (error) {
        console.error('Error en fetchFn:', error);
        Logger.error('Error en fetchFn:', error);
        throw error;
      }
    }
  }),
  tagTypes: ['Empresa', 'Textos', 'User', 'Dashboard', 'Cliente'], // Añadido 'Cliente' para permitir la invalidación
  endpoints: () => ({})
})

// No exportamos hooks aquí, se exportarán desde los slices que inyectan endpoints 